import React from "react"

import classNames from "gpages/utils/classnames"

import * as styles from "./nav.module.scss"
import logoImg from "@images/gatsby-icon.png"

const Nav = ({ location }) => {
  return (
    <nav className={classNames(styles.nav)}>
      <img src={logoImg} alt="logo" className={styles.logo} />
      <div className={styles.right}>
        <div>menu1</div>
        <div>menu2</div>
      </div>
    </nav>
  )
}

export default Nav
